import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { Link } from "react-router";
import Style from "@client/utils/Style";
import StatusImage from "@client/components/ui/StatusImage";

const Wrapper = styled.div`
  min-width: 332px;
  background: ${Style.palette.grayscale[0]};
  display: flex;
  overflow: auto;
  border-radius: ${Style.borderRadius};
`;
const CountBlock = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 32px 0;
  padding: 0 16px;
  border-left: 1px solid white;
  height: 96px;
  justify-content: center;
  &:first-child {
    border-left: 1px solid ${Style.palette.grayscale[0]};
  }

  @media (max-width: 832px) {
    align-items: flex-start;
  }
`;
const LoadingWrapper = styled.div`
  overflow: hidden;
  margin-bottom: 16px;
`;
const CountBlockValue = styled(Link)`
  font-size: 53px;
  font-weight: ${Style.fontWeights.light};
  text-decoration: none;
  color: inherit;
`;
const CountBlockLabel = styled(Link)`
  font-size: 12px;
  font-weight: ${Style.fontWeights.medium};
  text-transform: uppercase;
  color: ${props => props.color};
  text-decoration: none;
`;
type Props = {
  data: {
    label: string;
    value: number | null;
    color: string;
    link: string | null;
    loading: boolean;
  }[];
};
@observer
class DashboardInfoCount extends React.Component<Props> {
  render() {
    return (
      <Wrapper>
        {this.props.data.map(item => (
          <CountBlock key={item.label}>
            {!item.value && item.loading ? (
              <LoadingWrapper>
                <StatusImage status="RUNNING" size={48} />
              </LoadingWrapper>
            ) : (
              <CountBlockValue to={item.link || "#"}>
                {item.value != null ? item.value : "-"}
              </CountBlockValue>
            )}
            <CountBlockLabel color={item.color} to={item.link || "#"}>
              {item.label}
            </CountBlockLabel>
          </CountBlock>
        ))}
      </Wrapper>
    );
  }
}

export default DashboardInfoCount;
